import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry } from 'rxjs/operators';

import { ENPOINT } from '../endpoint';
import { Options } from 'selenium-webdriver/safari';

import { GLOBAL } from '../global';
import { CommentStmt } from '@angular/compiler';

@Injectable()
export class ReportPendingService {

  constructor(
    private http: HttpClient,
    
  ) { }
  public url = GLOBAL.url;
  private basePath = ENPOINT.url;

obtenerMasterFacturasPro(proveedor,fechai,fechaf,noDocPago): Observable<any> {
  const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('provedor', proveedor)
      .set('fechai', fechai)
      .set('fechaf', fechaf)
      .set('noDocPago', noDocPago) 
      .set('estatus', 'Pagada')
    };
    return this.http.get(this.basePath + 'master-factura/facturas-pendientes-complemento', options);
 }

obtenerZip(data): Observable<any> {
  const body = JSON.stringify(data);
  const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
  const options = {
    headers: httpHeaders,
    withCredentials: true,
  };
  return this.http.post(this.basePath + 'master-factura/obtener-zip', body, options);
 
}

cambiarStatus(uuid, estatus): Observable<any> {
  const headers = new HttpHeaders().set('Content-Type', 'application/json');
  const httpHeaders = new HttpHeaders();
  const options = {
    headers: httpHeaders,
    withCredentials: true,
    params: new HttpParams()
    .set('uuid', uuid)
    .set('estatus', estatus)
  };
  return this.http.put(this.basePath + 'master-factura/cambio-estatus', '', options);
}

cerrarComplemento(uuid): Observable<any> {
  const headers = new HttpHeaders().set('Content-Type', 'application/json');
  const httpHeaders = new HttpHeaders();
  const options = {
    headers: httpHeaders,
    withCredentials: true
  };
  return this.http.put(this.basePath + 'master-factura/cerrar-fact-para-comp/'+uuid, '', options);
}

downloadXml(base64Route: string) {
  const params = new HttpParams()
    .set('ruta', base64Route);

  return this.http.get(`${this.basePath}master-factura/obtener-xml`, { 
    responseType: 'blob',
    params 
  });
}

downloadPdf(base64Route: string) {
  const params = new HttpParams()
    .set('ruta', base64Route);

  return this.http.get(`${this.basePath}master-factura/obtener-pdf`, { 
    responseType: 'blob',
    params 
  });
}

downloadExcelReport(params): Observable<any> {
  return this.http.get(`${this.basePath}master-factura/excel-facturas-pendientes-complemento${params}`, { 
    responseType: 'blob' 
  });
}

}



// WEBPACK FOOTER //
// ./src/app/services/report-pending/report-pending.service.ts